import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { GeneralFileFormat } from '../../../models/GadgetModel';
import styles from "../css/GadgetFormatTable.module.css";
import { Typography } from '@mui/material';

interface GadgetFormatTableProps {
    headerText: string,
    fileFormats: GeneralFileFormat[] | undefined
}

export const GadgetFormatTable = ({headerText, fileFormats}: GadgetFormatTableProps) => {
  if(fileFormats === undefined) {
    return (
      <TableContainer>
        <Typography variant="body1" className={styles.headerText}>{headerText}</Typography>
        <Table aria-label="simple table" data-testid={"gadget-io-format-table"}>
          <Typography variant="body2" className={styles.noFormatText}>No {headerText} available for this agent</Typography>
        </Table>
      </TableContainer>
    )
  }

  return (
    <TableContainer>
        <Typography variant="body1" className={styles.headerText}>{headerText}</Typography>
      <Table aria-label="simple table" data-testid={"gadget-io-format-table"}>
        <TableHead>
          <TableRow>
            <TableCell>File Format</TableCell>
            <TableCell>File Extension</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fileFormats?.map((row) => (
            <TableRow
              key={row.file_format}
            >
              <TableCell component="th" scope="row">
                {row.file_format === "*" ? "all" : row.file_format}
              </TableCell>
              <TableCell>
                {row.file_extension === "*" ? "all" : row.file_extension}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}